module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-menu"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "menu-btn",
    on: {
      "click": _vm.shareBnt
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a5b5a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menuButton.vue
// module id = 47
// module chunks = 0